/**
 * Adds or removes the transaction security product from the cart.
 */
(function () {
  if (window.__transactionSecurityInit) {
    return;
  }

  window.__transactionSecurityInit = true;

  function getRoot(target) {
    return target ? target.closest('[data-transaction-security]') : null;
  }

  function getCheckbox(root) {
    return root ? root.querySelector('[data-transaction-security-checkbox]') : null;
  }

  function setSelected(root, selected) {
    var checkbox = getCheckbox(root);
    var toggle = root.querySelector('[data-transaction-security-toggle]');

    if (checkbox) {
      checkbox.checked = selected;
    }

    root.classList.toggle('is-selected', selected);

    if (toggle) {
      toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
      toggle.disabled = false;
    }
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function showError(root, message) {
    var existingError = root.querySelector('.CartTransactionSecurity__Error');

    if (existingError) {
      existingError.remove();
    }

    var errorMessageElement = document.createElement('span');
    errorMessageElement.className = 'CartTransactionSecurity__Error Alert Alert--error';
    errorMessageElement.textContent = message;
    root.appendChild(errorMessageElement);

    setTimeout(function () {
      errorMessageElement.remove();
    }, 5000);
  }

  function requestJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (content) {
        return {
          ok: response.ok,
          content: content
        };
      });
    });
  }

  function addItem(root) {
    var variantId = parseInt(root.getAttribute('data-variant-id'), 10);

    if (!variantId || !window.routes || !window.routes.cartAddUrl) {
      return;
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    requestJson(window.routes.cartAddUrl + '.js', {
      items: [{ id: variantId, quantity: 1 }]
    }).then(function (result) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (result.ok) {
        root.setAttribute('data-already-in-cart', 'true');
        setSelected(root, true);
        refreshCart();
      } else {
        setSelected(root, false);
        showError(root, result.content.description || result.content.message || 'Add to cart failed');
      }
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      setSelected(root, false);
    });
  }

  function removeItem(root) {
    var variantId = parseInt(root.getAttribute('data-variant-id'), 10);

    if (!variantId || !window.routes || !window.routes.cartChangeUrl) {
      return;
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    requestJson(window.routes.cartChangeUrl + '.js', {
      id: String(variantId),
      quantity: 0
    }).then(function (result) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (result.ok) {
        root.setAttribute('data-already-in-cart', 'false');
        setSelected(root, false);
        refreshCart();
      } else {
        setSelected(root, true);
        showError(root, result.content.description || result.content.message || 'Cart update failed');
      }
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      setSelected(root, true);
    });
  }

  function maybeAddDefault(root) {
    if (!root || root.getAttribute('data-already-in-cart') === 'true') {
      return;
    }

    if (root.getAttribute('data-selected-default') !== 'true') {
      return;
    }

    var checkbox = getCheckbox(root);

    if (!checkbox || !checkbox.checked) {
      return;
    }

    addItem(root);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-transaction-security-toggle]');

    if (!toggle || toggle.disabled) {
      return;
    }

    event.preventDefault();

    var root = getRoot(toggle);
    var checkbox = getCheckbox(root);

    if (!root || !checkbox) {
      return;
    }

    toggle.disabled = true;

    if (checkbox.checked) {
      removeItem(root);
    } else {
      addItem(root);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-transaction-security]').forEach(maybeAddDefault);
  });
})();
